import styled from 'styled-components';
import { DateRangeEmptyState } from 'ui/illustrations';
import { body2, colors, H4, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { useTranslations } from '../hooks/useTranslations';

const StyledEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  right: 0;
  top: 45%;
  align-items: center;
  row-gap: ${spacing.half};
`;

const StyledEmptyStateMessage = styled.span`
  ${body2};
  font-size: ${pxToRem(14)};
  color: ${colors.textSecondary};
  text-align: center;
  width: ${pxToRem(388)};
`;

const StyledH4 = styled(H4)`
  margin: 0;
`;

export const DATA_TEST_ID = 'empty-state';

export const EmptyIntegrationsState = () => {
  const { t } = useTranslations();

  return (
    <StyledEmptyState data-test={DATA_TEST_ID}>
      <DateRangeEmptyState />
      <StyledH4>{t('emptyState.noResults')}</StyledH4>
      <StyledEmptyStateMessage>{t('emptyState.noResultsMessage')}</StyledEmptyStateMessage>
    </StyledEmptyState>
  );
};
